import { ReactNode } from "react";
import styles from "./MediaMatch.module.scss";

interface MediaMatchProps {
  lessThan?: "small" | "medium" | "large" | "huge";
  greaterThan?: "small" | "medium" | "large" | "huge";
  children?: ReactNode;
  className?: string;
}

export default function MediaMatch({
  lessThan,
  greaterThan,
  children,
  className
}: MediaMatchProps) {
  const classNames = [
    styles.mediaMatch,
    lessThan &&
      styles[`lessThan${lessThan.charAt(0).toUpperCase() + lessThan.slice(1)}`],
    greaterThan &&
      styles[
        `greaterThan${greaterThan.charAt(0).toUpperCase() + greaterThan.slice(1)}`
      ],
    className
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={classNames}>{children}</div>;
}
